import { Component, Input } from '@angular/core';

@Component({
  selector: 'tooltip-intersection-area',
  templateUrl: './tooltip-intersection-area.component.html',
})
export class TooltipIntersectionAreaComponent {
  @Input() data: any;
}
